module.exports = __webpack_public_path__ + "img/index-multifocal.bbb311b5.svg";